import TableBody from "./TableBody";
import TableHead from "./TableHead";

function Table() {
    return (
        <table>
            <TableHead />
            <TableBody />
        </table>
    )
}

export default Table;